import _ from 'lodash';

/**
 * Remove private properties from the props object
 * private properties are marked with dangling underscore
 *
 * @param {object} props input props
 * @returns {object} props with private properties removed
 */
const removePrivateProps = (props) => {
  if (!props || Array.isArray(props) || typeof props !== 'object') {
    throw Error('props is expected to be an object');
  }
  const finalProps = {};
  Object.keys(props).forEach((key) => {
    if (!_.startsWith(key, '_')) {
      finalProps[key] = props[key];
    }
  });
  return finalProps;
};

export default removePrivateProps;



// WEBPACK FOOTER //
// ./src/utils/removePrivateProps.js